import "./_inputmask.min.js";
console.log('screener JS!!')
document.addEventListener("DOMContentLoaded", function () {
    Inputmask().mask(document.querySelectorAll("input"))
})